import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-health-dashboard',
  templateUrl: './health-dashboard.component.html',
  styleUrls: ['./health-dashboard.component.scss']
})
export class HealthDashboardComponent implements OnInit {


  ngOnInit(): void {
  }


  shortinfo = [{
    name: 'Skilled Mix',
    value:'72%',
    increase: 'Skilled Residents: 91',
    icon:'<i class="fa fa-pie-chart" aria-hidden="true"></i>',
    color:'#155dfc'
  },
  {
    name: 'Census',
    value:'127',
    increase: '+3',
    icon:'<i class="fa fa-user-o" aria-hidden="true"></i>',
    color:'#155dfc'
  },
  {
    name: 'Occupancy Rate',
    value:'94%',
    increase: '+2%',
    icon:'<i class="fa fa-bed" aria-hidden="true"></i>',
    color:'#00a63e'
  },
  {
    name: 'Overall Compliance',
    value:'92%',
    increase: '-1%',
    icon:'<i class="fa fa-shield" aria-hidden="true"></i>',
    color:'#9810fa'
  },
  {
    name: 'Admissions',
    value:'8',
    increase: 'last 72 hours',
    icon:'<i class="fa fa-user-plus" aria-hidden="true"></i>',
    color:'#f59e0b'
  },
  {
    name: 'Discharges & LCD',
    value:'7',
    increase: '4 planned + 3 LCD',
    icon:'<i class="fa fa-user-times" aria-hidden="true"></i>',
    color:'#d4183d'
  },
  {
    name: '20th Day Alert',
    value:'7',
    increase: 'Approaching Day 20',
    icon:'<i class="fa fa-calendar-o" aria-hidden="true"></i>',
    color:'#155dfc'
  }
]


  constructor(  private dialog: MatDialog,) { }


  selectedTab: string = 'Skilled Mix';

  addFolder(templateRef: TemplateRef<any>, name: string) {




    this.selectedTab = name;

    if( name === 'Census') {
      this.dialog.open(templateRef, {
        width: '40vw',
      });
    }else{
    this.dialog.open(templateRef, {
      width: '70vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    }

  }

  
}
